'use strict';
angular.module('schoolLinqApp').factory('accountStructureService', [
	'$http',
	function ($http) {
		var endpoint = '/api/account-structure';

		function getStructure() {
			return $http.get(endpoint);
		}

		function getStructureWithGrantYear() {
			return $http.get(endpoint + '/with-grant-year');
		}

		function getFunds() {
			return $http.get(endpoint + '/funds');
		}

		function getAccountTypes() {
			return $http.get(endpoint + '/types');
		}

		function saveStructure(structure) {
			return $http.put(endpoint, structure);
		}

		function usesNcNewAcctStructure() {
			return $http.get(endpoint + '/uses-nc-new-structure');
		}

		return {
			getStructure: getStructure,
			getFunds: getFunds,
			saveStructure: saveStructure,
			getAccountTypes: getAccountTypes,
			usesNcNewAcctStructure: usesNcNewAcctStructure,
			getStructureWithGrantYear: getStructureWithGrantYear,
		};
	},
]);
